import { Component } from "@angular/core";

@Component({
  selector: 'tr[app-dt-head-tr]',
  standalone: true,
  template: `<ng-content></ng-content>`,
  styleUrls: ['dt-head-tr.component.scss'],
})
export class DtHeadTrComponent {}
